var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.SHOPIFYBRANDS.includes(_vm.BRAND))?_c('ShopifyDispatch'):_c('OpenCartDispatch')}
var staticRenderFns = []

export { render, staticRenderFns }